<div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="exampleModalLabel1">Cargar Operación</h4>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        mat-dialog-close
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
   <!-- ##############
        FORM OPERACION
        ############## -->
        <h1>OPERACION</h1>
      <form [formGroup]="formOperacion">
        <div class="row">
          <div class="col-12 col-md-6">
            <!-- FECHA -->
            <mat-form-field class="custom-select-form">
              <mat-label>Fecha Transacción</mat-label>
              <input matInput [matDatepicker]="picker" formControlName="fecha">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <!-- IP -->
            <mat-form-field style="width: 100%;">
              <mat-label>IP</mat-label>
              <input
                type="text"
                formControlName="ip"
                matInput
                placeholder="Ingrese la ip de la operación."
              />
              <mat-error *ngIf="formOperacion.get('ip').hasError('required')"
                >La ip es <strong>requerida</strong></mat-error
              >
              <mat-error *ngIf="formOperacion.get('ip').hasError('pattern')"
                >La ip es <strong>invalida</strong></mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <!-- IP NO FINANCIERA -->
            <mat-form-field style="width: 100%;">
              <mat-label>Ip no financiera</mat-label>
              <input
                type="text"
                formControlName="ip_no_financiera"
                matInput
                placeholder="Ingrese su numero de cuenta"
              />
              <mat-error *ngIf="formOperacion.get('ip_no_financiera').hasError('required')"
                >La ip es <strong>requerida</strong></mat-error
              >
              <mat-error *ngIf="formOperacion.get('ip_no_financiera').hasError('pattern')"
                >La ip es <strong>invalida</strong></mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <!-- ESPECIALISTA -->
            <mat-form-field style="width: 100%;">
              <mat-label>Ip no financiera</mat-label>
              <input
                type="text"
                formControlName="ip_no_financiera"
                matInput
                placeholder="Ingrese su numero de cuenta"
              />
              <mat-error *ngIf="formOperacion.get('ip_no_financiera').hasError('required')"
                >La ip es <strong>requerida</strong></mat-error
              >
              <mat-error *ngIf="formOperacion.get('ip_no_financiera').hasError('pattern')"
                >La ip es <strong>invalida</strong></mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <!-- OBSERVACION -->
            <mat-form-field style="width: 100%;">
              <mat-label>Observación</mat-label>
              <input
                type="text"
                formControlName="observacion"
                matInput
                placeholder="Ingrese su numero de cuenta"
              />
              <mat-error *ngIf="formOperacion.get('observacion').hasError('required')"
                >La ip es <strong>requerida</strong></mat-error
              >
              <mat-error *ngIf="formOperacion.get('observacion').hasError('pattern')"
                >La ip es <strong>invalida</strong></mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <!-- CANAL -->
            <mat-form-field class="custom-select-form" style="width: 100%;">
              <mat-label>Canal/Producto</mat-label>
              <mat-select formControlName="id_canales" 
              (selectionChange)="obtenerTipoDeOperacion()">
                <mat-option
                  *ngFor="let canal of canales"
                  [value]="canal.id_canales"
                >
                  {{ canal.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <!-- TIPO OPERACION -->
            <mat-form-field class="custom-select-form" style="width: 100%;">
              <mat-label>Tipo de documento</mat-label>
              <mat-select formControlName="id_tipos_operaciones">
                <mat-option
                  *ngFor="let tipo of tiposOperaciones"
                  [value]="tipo.id_tipos_operaciones"
                >
                  {{ tipo.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </form>
   <!-- #####################
        SELECT CUENTAS ORIGEN
        ##################### -->
        <h1>CUENTA ORIGEN</h1>
      <form [formGroup]="formCuentaOrigen">
        <div class="row">
          <div class="col-12 col-md-12">
            <!-- OPERACION RELACION -->
            <mat-form-field class="custom-select-form" style="width: 100%;">
              <mat-label>Tipo de documento</mat-label>
              <mat-select formControlName="id_tipos_operaciones">
                <mat-option
                  *ngFor="let tipo of tiposOperaciones"
                  [value]="tipo.id_tipos_operaciones"
                >
                  {{ tipo.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </form>
  <!-- #####################
      OPERACION CUENTA ORIGEN
      ##################### -->
      <h1>OPERACION CUENTA DE ORIGEN</h1>
      <form [formGroup]="formOperacionCuentaOrigen">
        <div class="row">
          <div class="col-12 col-md-12">
          </div>
        </div>
      </form>
   <!-- ###################
        FORM CUENTA DESTINO
        ################### -->
      <H1>CUENTA DESTINO</H1>
      <form [formGroup]="formCuentaDestino">
        <div class="row">
          <div class="col-12 col-md-6">
            <!-- TITULAR -->
            <mat-form-field style="width: 100%;">
              <mat-label>Titular</mat-label>
              <input
                type="text"
                formControlName="titular"
                matInput
                placeholder="Ingrese el titular"
              />
              <mat-error *ngIf="formCuentaDestino.get('titular').hasError('required')"
                >El titular es <strong>requerido</strong></mat-error
              >
              <mat-error *ngIf="formCuentaDestino.get('titular').hasError('email')"
                >El titular es <strong>invalido</strong></mat-error
              >
            </mat-form-field>
          </div>
  
          <div class="col-12 col-md-6">
            <!-- NUMERO DE CUENTA -->
            <mat-form-field style="width: 100%;">
              <mat-label>Numero de Cuenta</mat-label>
              <input
                type="text"
                formControlName="numero_cuenta"
                matInput
                placeholder="Ingrese su numero de cuenta"
              />
              <mat-error *ngIf="formCuentaDestino.get('numero_cuenta').hasError('required')"
                >La cuenta es <strong>requerida</strong></mat-error
              >
              <mat-error *ngIf="formCuentaDestino.get('numero_cuenta').hasError('pattern')"
                >La cuenta es <strong>invalida</strong></mat-error
              >
            </mat-form-field>
          </div>
  
          <div class="col-12 col-md-6">
            <!-- TIPO DE DOCUMENTO -->
            <mat-form-field class="custom-select-form" style="width: 100%;">
              <mat-label>Tipo de documento</mat-label>
              <mat-select formControlName="tipo_documento">
                <mat-option
                  *ngFor="let tipo of tiposDocumentos"
                  [value]="tipo.name"
                >
                  {{ tipo.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="formCuentaDestino.get('tipo_documento').hasError('required')"
                >EL tipo documento es <strong>requerida</strong></mat-error
              >
              <mat-error *ngIf="formCuentaDestino.get('tipo_documento').hasError('maxlength')"
                >EL tipo documento debe tener solo un
                <strong>caracter</strong></mat-error
              >
            </mat-form-field>
          </div>
  
          <div class="col-12 col-md-6">
            <!-- NUMERO DE DOCUMENTO -->
            <mat-form-field style="width: 100%;">
              <mat-label>Documento</mat-label>
              <input
                type="text"
                formControlName="numero_documento_cuenta"
                matInput
                placeholder="Ingrese su Documento"
              />
              <mat-error
                *ngIf="formCuentaDestino.get('numero_documento_cuenta').hasError('required')"
                >El Documento es <strong>requerido</strong></mat-error
              >
              <mat-error
                *ngIf="formCuentaDestino.get('numero_documento_cuenta').hasError('pattern')"
                >El Documento es <strong>invalido</strong></mat-error
              >
            </mat-form-field>
          </div>
        </div>
        <!-- #####################
        OPERACION CUENTA ORIGEN
        ##################### -->
        <h1>OPERACION CUENTA DE DESTINO</h1>
        <form [formGroup]="formOperacionCuentaDestino">
          <div class="row">
            <div class="col-12 col-md-12">
            </div>
          </div>
        </form>
   <!-- ##############################
        FORM CUENTA DESTINO fINALIZADO
        ############################## -->
        <!-- <button
          (click)="onSubmit()"
          class="btn btn-info waves-effect float-right"
          [disabled]="form.status != 'VALID'"
        >
      <i class="far fa-save"></i>
          Guardar
        </button> -->
      </form>
    </div>
  </div>
  